import { useEventCallback } from '@mui/material/utils';
import { unawaited } from '../../utils/promise';
import { fromAuth, useAppDispatch } from '../../store';
import { useAccessToken } from '../providers/AccessTokenContext';

export function useSignOut() {
  const { signOut } = useAccessToken();

  const dispatch = useAppDispatch();

  const fn = useEventCallback(() => {
    dispatch(fromAuth.doPostSignOut());
    if (typeof signOut === 'function') {
      unawaited(signOut());
    }
  });

  return {
    signOutWithPath: typeof signOut === 'function' ? fn : undefined,
  };
}
